import * as React from 'react';
import {

    List,
    EditButton,
    Datagrid,
    TextField,
    Filter,
    ReferenceField,
    useListContext,
    TopToolbar,
    RichTextField,
} from 'react-admin';
import FormattedDateTimeField from '../../common/FormattedDateTimeField';
import { DeleteWithDialogAction } from "../../common/DeleteWithDialogAction";
import useIsPermission from '../../hooks/useIsPermission';
import { Link } from 'react-router-dom';
import { Add } from '@mui/icons-material';
import { Typography } from '@mui/material';
import { FaqCategoriesAutoComplete } from './FaqCategoriesAutocomplete';
import ConfirmDeleteButton from '../../common/ConfirmDeleteButton';

const ListFilter = (props: any) => (
    <Filter {...props}>
        <FaqCategoriesAutoComplete label="Faq Categories" source="category_id" alwaysOn reference="faq_categories" />
    </Filter>
);

const ListActions = () => {
    const { filterValues } = useListContext();
    const query = new URLSearchParams(filterValues).toString();

    return (
        <TopToolbar>
            <>
                <Link
                    to={`/faqs/create?${query}`}
                    style={{ textDecoration: 'none' }}
                >
                    <Add />   <Typography variant="button">Create</Typography>
                </Link>
            </>
        </TopToolbar>
    );
};
const FAQList = () => {
    const { isUpdatable, isDeletable, isWritable } = useIsPermission("FAQS");
    return (
        <div>
            <List
                queryOptions={{
                    refetchOnReconnect: false,
                    refetchOnWindowFocus: false,
                }}
                filters={<ListFilter />}
                actions={<ListActions />}
            >
                <Datagrid>
                    <TextField source="question" />
                    <RichTextField source="answer" />
                    <TextField source="displayOrder" />
                    <FormattedDateTimeField source="created_at" />
                    {isUpdatable &&
                        <EditButton />
                    }
                    {isDeletable &&
                        <ConfirmDeleteButton />
                    }
                </Datagrid>
            </List>
        </div>
    );
};
export default FAQList;